import * as React from "react";

import { Button } from "../";
import { ButtonProps, MessageComposer, MessageComposerProps } from "../..";

type MessageComposerStandardButtonProps = ButtonProps & MessageComposerProps;

export const MessageComposerStandardButton = (
    props: MessageComposerStandardButtonProps
) => {
    const {
        id,
        classes = "rooted",
        leadId,
        leadName,
        jobId,
        jobName,
        initialRecipients,
        attachments,
        initialBodyText,
        replyMessageId,
        color = "primary",
        variant = "contained",
        size = "small",
        title: buttonTitle = "send message",
        ...buttonProps
    } = props;

    const [messageComposerOpen, setMessageComposerOpen] = React.useState(
        () => false
    );

    return (
        <>
            <Button
                id={id}
                color={color}
                variant={variant}
                size={size}
                title={buttonTitle}
                onClick={() => setMessageComposerOpen(true)}
                {...buttonProps}
                data-cy="messageComposerButton"
            >
                {buttonTitle}
            </Button>
            {messageComposerOpen ? (
                <MessageComposer
                    leadName={leadName}
                    leadId={leadId}
                    jobName={jobName}
                    jobId={jobId}
                    open={messageComposerOpen}
                    initialRecipients={initialRecipients}
                    attachments={attachments}
                    initialBodyText={initialBodyText}
                    replyMessageId={replyMessageId}
                    onClose={() => setMessageComposerOpen(false)}
                />
            ) : null}
        </>
    );
};
